// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_incident_category_enum */
var FermentationIncidentCategoryEnum;
(function (FermentationIncidentCategoryEnum) {
    FermentationIncidentCategoryEnum["TEMPERATURE"] = "TEMPERATURE";
    FermentationIncidentCategoryEnum["PH"] = "PH";
    FermentationIncidentCategoryEnum["DO"] = "DO";
    FermentationIncidentCategoryEnum["PUMPS"] = "PUMPS";
    FermentationIncidentCategoryEnum["CHILLERS"] = "CHILLERS";
    FermentationIncidentCategoryEnum["OTHER_HARDWARE"] = "OTHER_HARDWARE";
    FermentationIncidentCategoryEnum["SOFTWARE"] = "SOFTWARE";
    FermentationIncidentCategoryEnum["USER"] = "USER";
    FermentationIncidentCategoryEnum["CONTAMINATION"] = "CONTAMINATION";
    FermentationIncidentCategoryEnum["MEOH_ACCUMULATION"] = "MEOH_ACCUMULATION";
    FermentationIncidentCategoryEnum["BIOLOGICAL"] = "BIOLOGICAL";
})(FermentationIncidentCategoryEnum || (FermentationIncidentCategoryEnum = {}));
;
export default FermentationIncidentCategoryEnum;
/** Zod schema for fermentation_incident_category_enum */
export const fermentationIncidentCategoryEnum = z.nativeEnum(FermentationIncidentCategoryEnum);
//# sourceMappingURL=FermentationIncidentCategoryEnum.js.map